module.exports = __webpack_public_path__ + "media/images/landing/client_VirginAmerica-842c27ea328a69eb7a2a284942955915.png";